export default {
  toolBar: {
    preview: {
      title: '预览',
      tipsContext: '如果没有自动跳转预览页面，请点击',
      tipsLink: '链接',
      full: '完整预览',
      beginWith: '从当前场景开始预览',
      disabledTip: '当前项目有节点未添加视频，请调整后再次尝试',
    },
    save: {
      title: '保存',
      success: '保存成功',
      error: '保存失败',
    },
    projectName: '项目信息',
    download: '下载',
    preparing: '准备中...',
    saveActionError: '保存 action 失败',
    repeated:
      '当前项目已在当前浏览器中打开进入编辑，同一项目仅允许打开一个编辑页。',
  },
  previewAction: {
    original: '原声',
    mute: '静音',
  },
  navbarMiddle: {
    newGroup: {
      tips: '组合 (Ctrl/Command + G)',
    },
    unGroup: {
      tips: '解除编组 (Ctrl/Command + Shift + G)',
    },
    copy: {
      tips: '复制 (Ctrl/Command + C)',
      record: '已记录到复制面板',
    },
    move: {
      title: '图层顺序',
      moveToTop: '置于顶层',
      moveToBottom: '置于底层',
      moveUp: '上移一层',
      moveDown: '下移一层',
    },
    paste: {
      success: '粘贴成功',
      title: '粘贴',
      justPasteTheLayerEvent: '仅粘贴图层事件',
      justPasteTheLayerAppearance: '仅粘贴图层外观',
      justPastePositionAndSize: '仅粘贴位置大小',
      justPasteTheLayerAnimation: '仅粘贴图层动画',
      pasteLayer: '粘贴图层(Ctrl/Command + V)',
    },
    redo: {
      title: '重做',
    },
    undo: {
      title: '撤回',
    },
  },
  recoverySound: '恢复声音',
  languageSelector: {
    placeholder: '请选择',
    label: '预览语言选择',
  },
}
